import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { PageFrame } from '../../components/PageFrame';
import type { AdultAuthService } from '../../platform/auth/adult-auth';

type Props = {
  auth: Pick<AdultAuthService, 'restoreSession'>;
  children: ReactNode;
};

export function RequireActiveSession({ auth, children }: Props) {
  const [status, setStatus] = useState<'checking' | 'ready' | 'expired'>(
    'checking',
  );
  useEffect(() => {
    let active = true;
    void auth
      .restoreSession()
      .then((session) => {
        if (active) setStatus(session ? 'ready' : 'expired');
      })
      .catch(() => {
        if (active) setStatus('expired');
      });
    return () => {
      active = false;
    };
  }, [auth]);

  if (status === 'expired') return <Navigate to="/auth/sign-in" replace />;
  if (status === 'checking') {
    return (
      <PageFrame title="Checking secure access" audience="adult">
        <p role="status" className="mt-4">
          Restoring your authorised workspace…
        </p>
      </PageFrame>
    );
  }
  return <>{children}</>;
}
